import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/w/employment-types')({
  staticData: { breadcrumb: 'Employment Types', breadcrumbKey: 'K_BREADCRUMB_EMPLOYMENT_TYPES' },
  component: EmploymentTypesLayout,
});

function EmploymentTypesLayout() {
  return <Outlet />;
}
